
        import * as module0 from './controllers/patient_form_controller.js';import * as module1 from './controllers/visibility_controller.js';import * as module2 from './controllers/zipcode_controller.js'
        const modules = {
            "./controllers/patient_form_controller.js": module0,
            "./controllers/visibility_controller.js": module1,
            "./controllers/zipcode_controller.js": module2,
        };
        export default modules;
      